import ReactModal from 'react-modal'

export const PostcodeSearchModal = ({ postcodeModal, setPostcodeModal, customPostcode, setCustomPostcode, nameSearch, setNameSearch, setLoading, getData }) => {
    return (
        <ReactModal
            isOpen={postcodeModal}
            onRequestClose={() => setPostcodeModal(false)}
            className="card bulk-allocate"
            contentLabel="Bulk Allocate COT Alert Data"
            style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <h3>Postcode Search</h3>
                <input
                    value={customPostcode}
                    autoFocus
                    onChange={_ => setCustomPostcode(_.target.value.toUpperCase())}
                    style={{ border: '1px solid gray', width: '100%', borderRadius: 3 }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && customPostcode?.length > 3) {
                            getData(customPostcode || undefined); setLoading(true); setPostcodeModal(false)
                        }
                    }}
                />
                {
                    setNameSearch &&
                    <>
                        <h3>Number or Name Search</h3>
                        <input
                            value={nameSearch}
                            onChange={_ => setNameSearch(_.target.value)}
                            style={{ border: '1px solid gray', width: '100%', borderRadius: 3 }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    getData(customPostcode || undefined); setLoading(true); setPostcodeModal(false)
                                }
                            }}
                        />
                    </>
                }
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                    <button className={`button compact smaller-text ${nameSearch || customPostcode?.length >= 3 ? 'background-primary colour-white' : ''}`} disabled={!nameSearch && customPostcode?.length < 3} onClick={() => { getData(customPostcode || undefined); setLoading(true); setPostcodeModal(false) }}>Search</button>
                </div>
            </div>
        </ReactModal>
    )
}
